export default __webpack_public_path__ + "static/media/maximiliano.9118f639.jpg";